module.exports = __webpack_public_path__ + "static/media/cancel-request.4c87393a.svg";